<ng-container *ngIf="service?.serviceForm?.hasForm else hasNoForm">
  @if (userProfile) {
    @if (allowed) {
      <div
        *ngIf="service?.serviceForm?.formType === 'FILLABLE'"
        class="w-full p-3">
        <div class="flex flex-col items-center ">
          <div *ngFor="let fillableForm of fillableForm$ | async" class="w-full px-3 flex flex-col items-center gap-1">
            <span class="font-medium text-xl">
              {{ fillableForm.name }}
            </span>
            <span class="text-muted font-bold">
              {{ fillableForm.description }}
            </span>
          </div>

          <div class="row w-full mt-3">
            <div *ngIf="supportForm" class="col-md-12 mx-auto">
              <main-dynamic-form
                (submit)="submitFillableForm($event)"
                [fields]="fields"
                [form]="supportForm"
                [showRequiredTitle]="false"
              >
              </main-dynamic-form>
            </div>

          </div>
        </div>

      </div>

      <div
        *ngIf="service.serviceForm.formType === 'UPLOADABLE'"
        class="container-fluid mt-3"
      >
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <h3 class="text-[#0F2167]" style="font-weight: 600">
              {{ "sample_forms" | translate }}
            </h3>
            <div>
              <div
                *ngFor="let sampleForm of sampleForms$ | async; let index = i"
                class=""
              >
                <div class=" rounded-md border border-[#0F2167] p-3">
                  <div class="text-[#0F2167]">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center">
                        <mat-icon svgIcon="file-stack"></mat-icon>
                        <span class="font-medium px-2">
                      {{ sampleForm.sampleFormTitle }}
                    </span>
                      </div>
                      <div
                        (click)="downloadSampleForm(sampleForm.sampleFormPath)"
                        class="underline cursor-pointer hover:text-[#FFC436]"
                      >
                        <mat-icon svgIcon="file_download"></mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- BEGIN: Upload forms -->
          <div class="col-lg-6 col-md-6 col-sm-6">
            <h3 class="text-[#0F2167]" style="font-weight: 600">
              {{ "upload_forms" | translate }}
            </h3>
            <div *ngIf="uploadableFormAttachments$ | async as attachments">
              <input
                #fileInput
                (change)="uploadAttachment($event.target.files[0])"
                [hidden]="true"
                accept="application/pdf"
                type="file"
              />
              <form
                (ngSubmit)="
              submitUploadableForm(uploadableFormAttachmentFormGroup.value)
            "
                [formGroup]="uploadableFormAttachmentFormGroup"
              >
                <ng-container formArrayName="requestCitizenAttachments">
                  <ng-container
                    *ngFor="
                  let formAttachment of serviceAttachments.controls;
                  let i = index
                "
                  >
                    <div [formGroup]="formAttachment" class="col-md-12">
                      <div
                        [ngClass]="{
                      'success-btn': isFileSelected(i),
                      'bg-[#FFF7E4]': !isFileSelected(i)
                    }"
                        class="border border-[#0F2167] my-1 p-2 rounded-md"
                      >
                        <div class="flex justify-between items-center flex-wrap">
                          <div
                            [ngClass]="{
                          'text-white': isFileSelected(i),
                          'text-muted': !isFileSelected(i)
                        }"
                            class="font-medium"
                          >
                            {{ attachments[i]?.attachmentTitle }}
                          </div>

                          <div
                            (click)="chooseAttachment(i, fileInput)"
                            *ngIf="!isFileSelected(i) && userProfile"
                            class="primary-btn rounded-md py-1 px-2 flex justify-center items-center font-normal cursor-pointer"
                            matRipple
                          >
                            <mat-icon svgIcon="upload"></mat-icon>
                            <span class="font-medium ml-1">{{
                                "upload" | translate
                              }}</span>
                          </div>
                        </div>

                        <div
                          *ngIf="isFileSelected(i)"
                          class="flex justify-between items-center flex-wrap"
                        >
                          <span>{{ viewFileSelected(i) }}</span>
                          <div
                            (click)="removeFileSelected(i)"
                            class="rounded-md danger-btn px-2 py-1 cursor-pointer"
                            matRipple
                          >
                            {{ "remove" | translate }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <div
                  *ngIf="userProfile; else loginSubmit"
                  class="flex justify-end mt-2"
                >
                  <button

                    [disabled]="uploadableFormAttachmentFormGroup.invalid"
                    class="bg-[#0F2167] p-2 rounded-md text-white"
                    type="submit"
                  >
                    {{ "submit" | translate }}
                  </button>
                </div>
                <ng-template #loginSubmit>
                  <div
                    class="p-2 rounded-md mt-3 text-center font-medium text-muted"
                  >
                    {{ "Ingia kwenye mfumo kuomba huduma hii"|concat|translate }}
                  </div>
                </ng-template>
              </form>
            </div>
          </div>
          <!-- END: Upload forms -->
        </div>
      </div>
    } @else {
            <div class=" text-primary-500 text-2xl  rounded p-4  mx-auto">
                <div class="flex justify-center items-center gap-1">
                  <mat-icon class="mx-1">info</mat-icon>
                  <span>
                  {{ 'Not Beneficiary of This Service'| concat | translate }}
                  </span>
                </div>
              </div>
    }
  } @else {
    <div class="w-full flex justify-center items-center">
      <div class="inline-flex justify-center ">
        <button (click)="showLogin()" class="button !text-white">
              <span class="button-content">
                {{ "Ingia kwenye mfumo kuomba huduma hii"|concat|translate }}
              </span>
        </button>
      </div>
    </div>

  }
</ng-container>

<ng-template #hasNoForm>
  @if (webSystem) {
    <div class=" text-primary-500 text-2xl flex flex-col gap-2 rounded p-4  mx-auto">
      <div class="flex justify-center items-center gap-1">
        <mat-icon class="mx-1">info</mat-icon>
        <span>
          {{ 'Request This service description'| concat | translate }}
          </span>
      </div>

      <div class="flex justify-center items-center gap-1">
        <button (click)="openWebSystem()" class="!bg-primary !text-white flex items-center rounded-sm px-3 py-2.5 text-lg">
          <mat-icon class="mx-1">open_in_new</mat-icon>
          {{ 'Request Here'| concat | translate }}
        </button>
      </div>
    </div>
  } @else {
    <div class=" text-primary-500 text-2xl  rounded p-4  mx-auto">
      <div class="flex justify-center items-center gap-1">
        <mat-icon class="mx-1">info</mat-icon>
        <span>
        {{ 'Cannot Request This Service'| concat | translate }}
        </span>
      </div>
    </div>
  }
</ng-template>
